import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue';
const Home = () => import('../views/Home.vue');
const Inicial = () => import('../views/Inicial.vue');
const InicialEdit = () => import('../views/InicialEdit.vue');
const Cliente = () => import('../views/Cliente.vue');
const Faturamento = () => import('../views/Faturamento.vue');
const Bloqueados = () => import('../views/Bloqueados.vue');
const AcessoRestrito = () => import('../views/AcessoRestrito.vue');
const SageSen = () => import('../views/SageSen.vue');
const Pedidos = () => import('../views/Pedidos.vue');
const GridChamadosNovo = () => import('../views/GridChamadosNovo.vue');
const Avisos = () => import('../views/Avisos.vue');
const MapaRede = () => import('../views/MapaRede.vue');
const Ajuda = () => import('../views/Ajuda.vue');


Vue.use(VueRouter)

const routes = [
  {
    path: '', redirect: {
      name: "login"
    }
  },
  {
    path: '/login', name: 'login', components: { router1: Login }, titulo: 'Login', menu: false
  },
  {
    path: '/Home', name: 'home', components: { router1: Home },
    children: [
      {
        path: 'inicial',
        name: 'inicial',
        components: { router2: Inicial },
      },
      {
        path: 'inicial/:id',
        name: 'inicial-edit',
        components: { router2: InicialEdit },
      },
      {
        path: 'maparede',
        name: 'maparede',
        components: { router2: MapaRede },
      },
      {
        path: 'cliente',
        name: 'cliente',
        components: { router2: Cliente },
      },
      {
        path: 'faturamento',
        name: 'faturamento',
        components: { router2: Faturamento },
      },
      {
        path: 'bloqueados',
        name: 'bloqueados',
        components: { router2: Bloqueados },
      },
      {
        path: 'restrito',
        name: 'restrito',
        components: { router2: AcessoRestrito },
      },
      {
        path: 'sagesen',
        name: 'sagesen',
        components: { router2: SageSen },
      },
      {
        path: 'pedidos',
        name: 'pedidos',
        components: { router2: Pedidos },
      },
      {
        path: 'novochamado',
        name: 'novochamado',
        components: { router2: GridChamadosNovo },
      },
      {
        path: 'avisos',
        name: 'avisos',
        components: { router2: Avisos },
      },
      {
        path: 'ajuda',
        name: 'ajuda',
        components: { router2: Ajuda },
      },
    ]
  }
]

const router = new VueRouter({
  routes: routes,
  //mode: 'history',
  history: true,
  //base: process.env.BASE_URL
  base:"",
  hashbang: false,
  root:"/"
})

export default router
